'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DomUtils = function () {
    function DomUtils() {
        _classCallCheck(this, DomUtils);
    }

    _createClass(DomUtils, [{
        key: 'ready',
        value: function ready(fn) {
            if (document.readyState != 'loading') {
                fn();
            } else {
                document.addEventListener('DOMContentLoaded', fn);
            }
        }
    }, {
        key: 'hasClass',
        value: function hasClass(elem, className) {
            return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
        }
    }, {
        key: 'addClass',
        value: function addClass(elem, className) {
            if (!this.hasClass(elem, className)) {
                elem.className += ' ' + className;
            }
        }
    }, {
        key: 'removeClass',
        value: function removeClass(elem, className) {
            var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
            if (this.hasClass(elem, className)) {
                while (newClass.indexOf(' ' + className + ' ') >= 0) {
                    newClass = newClass.replace(' ' + className + ' ', ' ');
                }
                elem.className = newClass.replace(/^\s+|\s+$/g, '');
            }
        }
    }, {
        key: 'toggleClass',
        value: function toggleClass(elem, className) {
            var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
            if (this.hasClass(elem, className)) {
                while (newClass.indexOf(' ' + className + ' ') >= 0) {
                    newClass = newClass.replace(' ' + className + ' ', ' ');
                }
                elem.className = newClass.replace(/^\s+|\s+$/g, '');
            } else {
                elem.className += ' ' + className;
            }
        }
    }, {
        key: 'preventDefault',
        value: function preventDefault(e) {
            e = e || window.event;
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }
    }, {
        key: 'preventDefaultForScrollKeys',
        value: function preventDefaultForScrollKeys(e) {
            var keys = {
                37: 1,
                38: 1,
                39: 1,
                40: 1
            };
            if (keys[e.keyCode]) {
                this.preventDefault(e);
                return false;
            }
        }
    }, {
        key: 'disableScroll',
        value: function disableScroll() {
            if (window.addEventListener) // older FF
                window.addEventListener('DOMMouseScroll', this.preventDefault, false);
            window.onwheel = this.preventDefault; // modern standard
            window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
            window.ontouchmove = this.preventDefault; // mobile
            document.onkeydown = this.preventDefaultForScrollKeys;
        }
    }, {
        key: 'enableScroll',
        value: function enableScroll() {
            if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
            window.onmousewheel = document.onmousewheel = null;
            window.onwheel = null;
            window.ontouchmove = null;
            document.onkeydown = null;
        }
    }, {
        key: 'getScroll',
        value: function getScroll() {
            if (window.pageYOffset != undefined) {
                return [pageXOffset, pageYOffset];
            } else {
                var sx,
                    sy,
                    d = document,
                    r = d.documentElement,
                    b = d.body;
                sx = r.scrollLeft || b.scrollLeft || 0;
                sy = r.scrollTop || b.scrollTop || 0;
                return [sx, sy];
            }
        }
    }, {
        key: 'getDocumentHeight',
        value: function getDocumentHeight() {
            return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        }
    }, {
        key: 'getViewHeight',
        value: function getViewHeight() {
            return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        }
    }, {
        key: 'offset',
        value: function offset(elem) {
            var rect = elem.getBoundingClientRect();

            return {
                top: rect.top + this.getScroll()[1],
                left: rect.left + this.getScroll()[0]
            };
        }
    }, {
        key: 'getElementScrollPos',
        value: function getElementScrollPos(elem) {
            var elemPos = this.offset(elem).top;
            var vh = this.getViewHeight();

            return elemPos;
        }
    }]);

    return DomUtils;
}();

;

var domUtils = new DomUtils();
